import { Skeleton } from '../../../components/ui/skeleton';
import { m } from '../../../paraglide/messages';

/** The line widths for the three shimmer rows, matching the mock's rhythm. */
const SHIMMER_ROWS = [
  { name: '46%', desc: '72%' },
  { name: '38%', desc: '64%' },
  { name: '42%', desc: '58%' },
];

/**
 * State 2: an explicit in-progress state for a running semantic search - a
 * spinner header ("Matching endpoints to your use case...") plus shimmer skeleton
 * rows, visibly distinct from the instant keyword filter (which never spins).
 */
export const CatalogSearchSkeleton = () => (
  <div>
    <div className="flex items-baseline justify-between gap-3 px-4 pt-2.5 pb-1.5">
      <span className="mono flex items-center gap-2 text-11 font-semibold tracking-[0.07em] text-accent uppercase">
        <span className="size-3 animate-spin rounded-full border-[1.6px] border-accent-line border-t-accent" />
        {m.search_matching()}
      </span>
      <span className="mono text-11 text-text-3">{m.search_embeddings()}</span>
    </div>
    {SHIMMER_ROWS.map((r, i) => (
      <div key={i} className="flex items-center gap-3 px-4 py-2.5">
        <Skeleton className="size-7 rounded-8" />
        <div className="flex flex-1 flex-col gap-1.5">
          <Skeleton className="h-3" style={{ width: r.name }} />
          <Skeleton className="h-2.5" style={{ width: r.desc }} />
        </div>
        <Skeleton className="h-3 w-14.5" />
      </div>
    ))}
  </div>
);
